import * as React from "react";
import { CheckmarkCircle48Regular } from "@fluentui/react-icons";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { InlineActionButton } from "../../actionButton/ActionButton";

export interface IJobCreatedViewProps {
    allocateDistributionConfirmationClose?: () => void;
    hideModal:typeof hideModal;
    textToScreen?:string;
}

const JobCreatedView: React.SFC<IJobCreatedViewProps> = ({hideModal,textToScreen,allocateDistributionConfirmationClose}) => {
   

    const buttonCloseAction = () => {
        allocateDistributionConfirmationClose()
        hideModal();
    }
    return (
        <div className="jobCreatedView">
            <CheckmarkCircle48Regular className="jobCreatedViewIcon" />
            <div className="loadingView">
                <div className="loadingViewText"> {textToScreen} </div>
            </div>
            <div className="button-separator"></div>
            <div className="jobCreatedViewButtonRow">
                <InlineActionButton
                buttonText="Close"
                buttonAction={buttonCloseAction}
                disabled={false}
                className="button btn-defaultPrimary" />
            </div>
            
            
        </div>
        
    );
};

export default JobCreatedView;